import { createSlice } from '@reduxjs/toolkit'
import { UserState } from '../../types/store-types/user-types'



const initialState: UserState = {
  user: null
}



const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setAuth: (state, action) => {
        state.user = action.payload
    },
    unsetAuth: (state) => {
        state.user = null
    }
  },
})

// Action creators are generated for each case reducer function
export const { setAuth, unsetAuth } = userSlice.actions

export default userSlice.reducer